var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Usuário ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": _vm.edit ? 12 : 8
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do Usuário*",
      "outlined": "",
      "maxlength": "80",
      "counter": "80",
      "readonly": _vm.edit,
      "dense": "",
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.content.nomeCompleto,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nomeCompleto", $$v);
      },
      expression: "content.nomeCompleto"
    }
  })], 1), !_vm.edit ? _c('v-col', {
    staticClass: "d-flex align-center margin-top-negative",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._v(" Inserir Nome Social "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var on = _ref.on,
                attrs = _ref.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "right": ""
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v("mdi-chat-question-outline")])];
            }
          }], null, false, 1842650894)
        }, [_c('span', {
          staticClass: "custom-tooltip"
        }, [_vm._v(" Nome social é a designação pela qual a pessoa travesti ou transexual se identifica"), _c('br'), _vm._v(" e é socialmente reconhecida e DEVERÁ SER COMPOSTO POR PRENOME, ACRESCIDO DO(S) "), _c('br'), _vm._v(" ACRESCIDO DO(S) SOBRENOME(S) FAMILIAR(ES) CONSTANTE(S) DO NOME CIVIL, não podendo ser irreverente"), _c('br'), _vm._v(" ou atentar contra o pudor. ")])])];
      },
      proxy: true
    }], null, false, 4284893233),
    model: {
      value: _vm.form.dados.inserirNomeSocial,
      callback: function ($$v) {
        _vm.$set(_vm.form.dados, "inserirNomeSocial", $$v);
      },
      expression: "form.dados.inserirNomeSocial"
    }
  })], 1) : _vm._e()], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_vm.form.dados.inserirNomeSocial && !_vm.edit ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome Social",
      "outlined": "",
      "maxlength": "80",
      "counter": "80",
      "dense": "",
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.content.nomeSocial,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nomeSocial", $$v);
      },
      expression: "content.nomeSocial"
    }
  })], 1) : _vm._e()], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }],
    attrs: {
      "label": "CPF*",
      "outlined": "",
      "dense": "",
      "maxlength": "14",
      "counter": "14",
      "rules": [[_vm.$required], function (v) {
        return _vm.$validarCpf(v);
      }],
      "readonly": _vm.edit
    },
    model: {
      value: _vm.content.cpf,
      callback: function ($$v) {
        _vm.$set(_vm.content, "cpf", $$v);
      },
      expression: "content.cpf"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail*",
      "outlined": "",
      "dense": "",
      "maxlength": "120",
      "counter": "120",
      "rules": [[_vm.$required], function (v) {
        return _vm.$email(v);
      }],
      "readonly": _vm.edit
    },
    model: {
      value: _vm.content.email,
      callback: function ($$v) {
        _vm.$set(_vm.content, "email", $$v);
      },
      expression: "content.email"
    }
  })], 1)], 1), _vm.edit ? _c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.form.lists.listPerfis,
      "item-text": 'nome',
      "item-value": 'id',
      "rules": _vm.edit ? [function (p) {
        return p && p.length > 0 || 'Campo obrigatório';
      }] : [],
      "label": "Perfil*",
      "multiple": "",
      "outlined": "",
      "dense": "",
      "return-object": ""
    },
    model: {
      value: _vm.content.perfis,
      callback: function ($$v) {
        _vm.$set(_vm.content, "perfis", $$v);
      },
      expression: "content.perfis"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": _vm.edit ? 'Salvar' : 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": _vm.fechar
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }